import Card from './productCard/Card';
import ListItem from './productCard/ListItem';
import Small from './productCard/Small';

export default {
	Card,
	Small,
	ListItem,
};
